module.exports = __webpack_public_path__ + "static/img/animal.9529f021.svg";